<template>
  <v-container fluid>
    <!-- รายงานตัวเลือกสถานศึกษา ครูผู้ช่วย -->
    <v-hover v-slot="{ hover }">
      <v-card
        :elevation="hover ? 20 : 4"
        :class="{ 'on-hover': hover }"
        class="alert-card"
        v-if="periodassteachsCh.periodAssTeachEnable === '1' || periodassteachsCh.periodAssTeachEnable === 1"
      >
        <div class="alert-stripe urgent-stripe"></div>
        <v-card-text class="alert-content pa-6">
          <v-row align="center">
            <v-col cols="12" lg="8">
              <div class="alert-header">
                <v-icon color="error" size="40" class="mr-3">mdi-domain</v-icon>
                <div class="header-content">
                  <div class="department-badge mb-2">
                    <v-chip color="error" text-color="white" class="font-weight-bold">
                      <v-icon left small>mdi-domain</v-icon>
                      กจ2. สอ. สอศ.
                    </v-chip>
                  </div>
                  <h2 class="alert-title">
                    รายงานตัวเลือกสถานศึกษา ครูผู้ช่วย
                  </h2>
                  <div class="period-info">
                    <v-chip 
                      color="primary" 
                      outlined 
                      class="mr-2 mb-2"
                    >
                      <v-icon left small>mdi-calendar</v-icon>
                      ครั้งที่ {{ periodassteachsCh.periodAssTeachTimes }}
                    </v-chip>
                    <v-chip 
                      color="info" 
                      outlined 
                      class="mb-2"
                    >
                      <v-icon left small>mdi-calendar-clock</v-icon>
                      ปี {{ periodassteachsCh.periodAssTeachYear }}
                    </v-chip>
                  </div>
                </div>
              </div>
            </v-col>
            
            <v-col cols="12" lg="4">
              <div class="alert-actions">
                <v-btn
                  color="info"
                  x-large
                  rounded
                  to="/pages/manage_college_manpower"
                  class="action-btn"
                >
                  <v-icon left>mdi-school</v-icon>
                  ติดตามการรายงานตัว
                </v-btn>
                
                <v-btn 
                  icon
                  color="red"
                  @click="VideoDialog()"
                  class="video-btn mt-2"
                >
                  <v-icon>mdi-play-circle</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <!-- Additional Info Section -->
          <v-row class="mt-4" v-if="periodassteachsCh.periodAssTeachStop">
            <v-col cols="12">
              <v-card class="info-card" outlined>
                <v-card-text class="pa-4">
                  <v-row align="center">
                    <v-col cols="12" md="4">
                      <div class="info-item">
                        <v-icon color="success" class="mr-2">mdi-calendar-check</v-icon>
                        <div>
                          <strong>เริ่มรายงานตัว:</strong><br>
                          <span class="text-success">
                            {{ periodassteachsCh.periodAssTeachStart | moment("add", "543 years") | moment("D MMMM YYYY") }}
                          </span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="info-item">
                        <v-icon color="warning" class="mr-2">mdi-clock-outline</v-icon>
                        <div>
                          <strong>สิ้นสุดการรายงานตัว:</strong><br>
                          <span class="deadline-text">
                            {{ periodassteachsCh.periodAssTeachStop | moment("add", "543 years") | moment("D MMMM YYYY") }}
                          </span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="info-item">
                        <v-icon color="info" class="mr-2">mdi-account-group</v-icon>
                        <div>
                          <strong>สถานะระบบ:</strong><br>
                          <v-chip 
                            :color="systemStatusColor" 
                            text-color="white" 
                            small
                          >
                            {{ systemStatusText }}
                          </v-chip>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Countdown Section -->
          <v-row class="mt-4" v-if="timeRemaining && timeRemaining.totalMs > 0">
            <v-col cols="12">
              <v-card class="countdown-card" color="primary" dark>
                <v-card-text class="text-center pa-4">
                  <h3 class="mb-3">
                    <v-icon class="mr-2">mdi-timer-sand</v-icon>
                    เหลือเวลาในการรายงานตัว
                  </h3>
                  <flip-countdown
                    :deadline="periodassteachsCh.periodAssTeachStop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>

   
    <!-- Statistics Card -->
    <v-card class="statistics-card mt-4" outlined v-if="periodassteachsCh.periodAssTeachEnable === '1' || periodassteachsCh.periodAssTeachEnable === 1">
      <v-card-title class="pb-2">
        <v-icon color="info" class="mr-2">mdi-chart-bar</v-icon>
        สถิติการรายงานตัว
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-card class="stat-item" color="blue lighten-5">
              <v-card-text class="text-center pa-3">
                <v-icon color="blue" size="30" class="mb-2">mdi-account-multiple</v-icon>
                <h3 class="blue--text">{{ statistics.totalSlots || '-' }}</h3>
                <p class="mb-0">จำนวนที่เปิดรับ</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card class="stat-item" color="green lighten-5">
              <v-card-text class="text-center pa-3">
                <v-icon color="green" size="30" class="mb-2">mdi-account-check</v-icon>
                <h3 class="green--text">{{ statistics.reported || '-' }}</h3>
                <p class="mb-0">รายงานตัวแล้ว</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card class="stat-item" color="orange lighten-5">
              <v-card-text class="text-center pa-3">
                <v-icon color="orange" size="30" class="mb-2">mdi-account-clock</v-icon>
                <h3 class="orange--text">{{ statistics.pending || '-' }}</h3>
                <p class="mb-0">รอรายงานตัว</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card class="stat-item" color="purple lighten-5">
              <v-card-text class="text-center pa-3">
                <v-icon color="purple" size="30" class="mb-2">mdi-percent</v-icon>
                <h3 class="purple--text">{{ reportingPercentage }}%</h3>
                <p class="mb-0">เปอร์เซ็นต์</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Video Dialog -->
    <v-dialog v-model="VideoDialogYoutube" max-width="800px">
      <v-card>
        <v-card-title class="flex-between">
          <span class="headline">คู่มือการรายงานตัวเลือกสถานศึกษา</span>
          <v-btn icon @click="VideoDialogYoutubeStop()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="video-container">
            <p class="text-center text-muted">
              วิดีโอแนะนำขั้นตอนการรายงานตัวเลือกสถานศึกษาจะแสดงที่นี่
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      <v-icon v-if="snackbar.icon" left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "AssistantTeacherCollegeSelection",
  components: { FlipCountdown },
  
  data() {
    return {
      loading: false,
      VideoDialogYoutube: false,
      ApiKey: "HRvec2021",
      periodassteachsCh: {},
      interval: null,
      dateNows: null,
      dateStops: null,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      statistics: {
        totalSlots: 0,
        reported: 0,
        pending: 0
      },
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      }
    };
  },

  async mounted() {
    await this.loadData();
  },

  beforeDestroy() {
    // Clear interval เมื่อ component ถูกทำลาย
    if (this.interval) {
      clearInterval(this.interval);
    }
  },

  methods: {
    async loadData() {
      this.loading = true;
      try {
        await this.periodassteachChoose();
        await this.loadStatistics();
        this.showSnackbar('โหลดข้อมูลสำเร็จ', 'success', 'mdi-check-circle');
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการโหลดข้อมูล', 'error', 'mdi-alert-circle');
        console.error('Error loading data:', error);
      } finally {
        this.loading = false;
      }
    },

    async periodassteachChoose() {
      try {
        let result_period = await this.$http.post("periodassteach.php", {
          ApiKey: this.ApiKey,
          periodAssTeachEnable: "1",
          periodAssTeachID: "101"
        });
        
        this.periodassteachsCh = result_period.data;
            // ตั้งค่า interval สำหรับตรวจสอบเวลา
        if (this.periodassteachsCh.periodAssTeachEnable == "1" || this.periodassteachsCh.periodAssTeachEnable == 1) {
          this.setupTimeCheck();
        }
      } catch (error) {
        console.error('Error fetching period data:', error);
        throw error;
      }
    },

    setupTimeCheck() {
      // Clear interval เก่าก่อน (ถ้ามี)
      if (this.interval) {
        clearInterval(this.interval);
      }

      let dateNow = new Date();
      let dateStop = new Date(this.periodassteachsCh.periodAssTeachStop + " 16:30:00");
      this.dateNows = dateNow.getTime();
      this.dateStops = dateStop.getTime();

      // ตรวจสอบทุก 3 วินาที
      this.interval = setInterval(async () => {
        let currentTime = new Date().getTime();
        if (currentTime > this.dateStops) {
          try {
            this.periodassteachsCh.ApiKey = this.ApiKey;
            this.periodassteachsCh.periodAssTeachEnable = "0";
            
            await this.$http.post("periodassteach.update.php", this.periodassteachsCh);
            await this.periodassteachChoose();
            
            this.showSnackbar('ระบบได้ปิดการรายงานตัวแล้ว', 'warning', 'mdi-alert');
            
            // Clear interval เมื่อระบบปิด
            if (this.interval) {
              clearInterval(this.interval);
              this.interval = null;
            }
          } catch (error) {
            console.error('Error updating period:', error);
          }
        }
      }, 3000);
    },

    async loadStatistics() {
      // จำลองการโหลดสถิติ - ในการใช้งานจริงจะเรียก API
      try {
        // สามารถเพิ่ม API call ที่นี่
        this.statistics = {
          totalSlots: 150,
          reported: 89,
          pending: 61
        };
      } catch (error) {
        console.error('Error loading statistics:', error);
      }
    },

    async VideoDialog() {
      this.VideoDialogYoutube = true;
    },

    async VideoDialogYoutubeStop() {
      const videos = document.querySelectorAll("iframe, video");
      Array.prototype.forEach.call(videos, function(video) {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          const src = video.src;
          video.src = src;
        }
      });
      this.VideoDialogYoutube = false;
    },

    showSnackbar(text, color = 'info', icon = 'mdi-information') {
      this.snackbar = {
        show: true,
        text,
        color,
        icon,
        timeout: 5000
      };
    },

    async refreshData() {
      await this.loadData();
    }
  },

  computed: {
    isSystemActive() {
      return this.periodassteachsCh.periodAssTeachEnable === '1' || this.periodassteachsCh.periodAssTeachEnable === 1;
    },

    systemStatusColor() {
      return this.isSystemActive ? 'success' : 'grey';
    },

    systemStatusText() {
      return this.isSystemActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน';
    },

    timeRemaining() {
      if (!this.periodassteachsCh.periodAssTeachStop) return null;
      
      const now = new Date();
      const deadline = new Date(this.periodassteachsCh.periodAssTeachStop + ' 16:30:00');
      const diff = deadline - now;
      
      if (diff <= 0) return null;
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      
      return { days, hours, totalMs: diff };
    },

    reportingPercentage() {
      if (!this.statistics.totalSlots || this.statistics.totalSlots === 0) return 0;
      return Math.round((this.statistics.reported / this.statistics.totalSlots) * 100);
    }
  },

  watch: {
    'periodassteachsCh.periodAssTeachEnable'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        const message = newVal === '1' || newVal === 1 ? 
          'ระบบรายงานตัวเลือกสถานศึกษาได้เปิดใช้งานแล้ว' : 
          'ระบบรายงานตัวเลือกสถานศึกษาได้ปิดใช้งานแล้ว';
        const color = newVal === '1' || newVal === 1 ? 'success' : 'warning';
        this.showSnackbar(message, color, 'mdi-bell-ring');
      }
    }
  }
};
</script>

<style scoped>
/* Alert Dashboard Styles */
.college-selection-alert {
  margin-bottom: 24px;
}

/* Alert Cards */
.alert-card {
  border-radius: 15px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.alert-card:hover {
  transform: translateY(-3px);
}

.alert-card.on-hover {
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}

.inactive-card {
  background: #fafafa;
}

.alert-stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
}

.urgent-stripe {
  background: linear-gradient(to bottom, #f44336, #e91e63);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

.alert-content {
  padding-left: 10px;
}

.alert-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}

.header-content {
  flex: 1;
}

.department-badge {
  margin-bottom: 8px;
}

.alert-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  line-height: 1.3;
}

.period-info {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.deadline-text {
  font-size: 0.95rem;
  color: #f44336;
  font-weight: 500;
}

.alert-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.action-btn {
  border-radius: 10px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-width: 180px;
}

.action-btn:hover {
  transform: translateY(-2px);
}

.video-btn {
  border-radius: 50% !important;
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
}

/* Info Cards */
.info-card {
  border-radius: 10px !important;
  background: #f8f9fa;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.info-item:last-child {
  margin-bottom: 0;
}

/* Countdown Card */
.countdown-card {
  border-radius: 15px !important;
}

/* Statistics Card */
.statistics-card {
  border-radius: 10px !important;
}

.stat-item {
  border-radius: 10px !important;
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Countdown Timer Styles */
.countdown-timer >>> .flip-countdown {
  font-family: "Roboto", sans-serif;
}

.countdown-timer >>> .flip-countdown__piece {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 5px;
  font-size: 1rem;
  min-width: 40px;
  height: 40px;
  backdrop-filter: blur(10px);
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 5px;
}

/* Video Dialog */
.video-container {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 10px;
}

/* Utility classes */
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-muted {
  color: #666 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .alert-title {
    font-size: 1.2rem;
  }

  .alert-actions {
    margin-top: 20px;
  }

  .action-btn {
    min-width: 140px;
  }

  .period-info {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .alert-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .alert-header .v-icon {
    margin-bottom: 10px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .info-item .v-icon {
    margin-bottom: 5px;
  }
}

/* Animation Effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-card {
  animation: fadeInUp 0.6s ease-out;
}

.info-card {
  animation: fadeInUp 0.6s ease-out;
  animation-delay: 0.1s;
  animation-fill-mode: both;
}

.statistics-card {
  animation: fadeInUp 0.6s ease-out;
  animation-delay: 0.2s;
  animation-fill-mode: both;
}

/* Vue transitions */
.v-application {
  font-family: "Sarabun", "Roboto", sans-serif !important;
}

.v-btn {
  text-transform: none !important;
  font-weight: 500 !important;
}

.v-card {
  transition: all 0.3s ease !important;
}

/* Focus states for accessibility */
.action-btn:focus {
  outline: 2px solid #2196f3;
  outline-offset: 2px;
}

.alert-card:focus-within {
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.3);
}

/* Custom chip styles */
.v-chip.v-chip--outlined {
  border-width: 2px;
}

/* Text color utilities */
.text-success {
  color: #4caf50 !important;
}
</style>